import UserOutlinedIcon from '@uala/icons/UserOutlinedIcon';
import React from 'react';

interface UseAvatarInitials {
  (children: React.ReactNode): {
    children: React.ReactNode | string;
    backgroundColor?: string;
    color?: string;
  };
}

const stringToColour = (str: string): string => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
};

const getContrastColor = (hexcolor: string): string => {
  const r = parseInt(hexcolor.substr(1, 2), 16);
  const g = parseInt(hexcolor.substr(3, 2), 16);
  const b = parseInt(hexcolor.substr(5, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? 'black' : 'white';
};

const getInitials = (name: string) => {
  let initials = '';

  const words = name.split(' ').filter(Boolean);
  if (words[0]) {
    initials += words[0].charAt(0);
  }
  if (words.length > 1 && words[words.length - 1]) {
    initials += words[words.length - 1].charAt(0);
  }

  return initials;
};

const useAvatarInitials: UseAvatarInitials = (children: React.ReactNode) => {
  if (typeof children !== 'string') {
    return { children };
  } else if (children.trim() === '') {
    return {
      children: <UserOutlinedIcon color="#fff" fontSize="28" />
    };
  }

  const name = children;
  const backgroundColor = stringToColour(name);
  return {
    children: getInitials(name).toUpperCase(),
    style: {
      backgroundColor,
      color: getContrastColor(backgroundColor)
    }
  };
};

export default useAvatarInitials;
